export const hasExpressionDelimiters = (value: string): boolean =>
  !!(value.match("^{{") && value.match("}}$"));
